import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Stack, Typography } from "@mui/material";

function Pill({ children, sx }) {
  return (
    <Box
      sx={{
        px: 2.5,
        py: 1.1,
        bgcolor: "secondary.50",
        borderRadius: "33px",
        boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default function StockPageHeader({ title, onBack, backDisabled = false }) {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: "center", justifyContent: "space-between" }}
    >
      <IconButton
        aria-label="Volver"
        onClick={onBack}
        disabled={backDisabled}
        sx={{
          width: 36,
          height: 36,
          bgcolor: "secondary.500",
          "&:hover": { bgcolor: "secondary.600" },
          "&.Mui-disabled": { bgcolor: "secondary.100", opacity: 0.7 },
        }}
      >
        <ArrowBackIcon sx={{ color: "logoblanco", fontSize: 32 }} />
      </IconButton>

      <Stack sx={{ flex: 1, alignItems: "center", pr: "48px" }}>
        <Pill sx={{ bgcolor: "secondary.200" }}>
          <Typography sx={{ fontSize: 18, fontWeight: 600, color: "primary.900" }}>
            {title}
          </Typography>
        </Pill>
      </Stack>
    </Stack>
  );
}
